module.exports = __webpack_public_path__ + "img/4-2.75f1d354.svg";